const state = {
  timeOutNum: 0,
  timeObj: undefined,
};

// getters
const getters = {
  timeOutNum(state) {
    return state.timeOutNum;
  },
  timeObj(state) {
    return state.timeObj;
  },
};

// actions
const actions = {
  setTimeoutObj({ state, commit }) {
    let timeOutNumber = 60;
    if (state.timeObj) {
      clearInterval(state.timeObj);
      commit('setTimeObj');
    }
    commit('setTimeOutNum', timeOutNumber);
    let timeObject = setInterval(() => {
      timeOutNumber = timeOutNumber - 1;
      commit('setTimeOutNum', timeOutNumber);
      if (timeOutNumber == 0) {
        clearInterval(timeObject);
        timeObject = undefined;
      }
    }, 1000);
    commit('setTimeObj', timeObject);
  },
};

// mutations
const mutations = {
  setTimeOutNum(state, timeOutNumber) {
    state.timeOutNum = timeOutNumber;
  },
  setTimeObj(state, timeObject) {
    state.timeObj = timeObject;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
